module.exports = __webpack_public_path__ + "static/media/edit_color.61369f4b.svg";